import { isoShortDate } from './isoShortDate';

export function beforeToday(date) {
  if (!date) throw new Error('Date is required');
  const today = isoShortDate(new Date());
  const inputDate = date;
  // console.log({ today, inputDate });
  return inputDate < today;
}
